import { IsSuppressing } from 'src/app/model/extra-params';
import { EnvService } from './../../env.service';
import { ZoomToToolsComponent } from './../zoom-to-tools/zoom-to-tools.component';
import { SLMap } from 'src/app/model/sl-map';
// @ts-ignore
import { Marker, LngLat, Popup, Point as MBPoint } from '!mapbox-gl';
import { PUCComponent, IActionMap } from './p-u-c.component';
import { ResultPopupComponent } from '../result-popup/result-popup.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Synchable, SynchEvent, SynchSelectionsEvent } from 'src/app/model/synchronizer';
import { ResultMoment } from 'src/app/services/results.service';
import { ResultHistory } from 'src/app/model/result-history';
import { request } from 'http';
import { Point } from 'proj4';
import { DrawPaneComponent } from '../draw-pane/draw-pane.component';


export class PUCManager {
  public aniIcon = '';
  protected map: SLMap;
  protected queryMarker: Marker;
  protected inMap: boolean;
  protected puc: PUCComponent;
  protected resultsPopup: ResultPopupComponent;
  protected results: any;
  protected subscriptions: SubScriptionMgr = new SubScriptionMgr();
  protected popupSubscriptions: SubScriptionMgr = new SubScriptionMgr();
  protected popup: Popup;
  protected actionMaps: Array<IActionMap>;
  protected synchProxy: Synchable;
  protected moment: ResultMoment;
  protected isSynchingFeature = false;
  public autoShow = true;
  constructor(slMap: SLMap) {
    const me = this;

    this.synchProxy = {
      synchId: 'popup-control',
      channel: ResultHistory.LATEST_ID,
      synchables: [],
      handler: (event: SynchEvent) => {
        me.HandleSynchEvent(event);
      }

    }
    slMap.resultsService.AddSynchable(this.synchProxy);

    this.map = slMap;
    this.actionMaps = [{
      ul: { class: 'fas fa-comment-alt', secondary: '', action: 'open-popup' },
      ur: { class: 'fas fa-times', secondary: '', action: 'close-puc' },
      ll: { class: 'fas fas fa-list', secondary: 'secondary fas fa-caret-down', action: 'send-to-results' },
      lr: { class: 'fas fas fa-list', secondary: 'secondary fas fa-caret-up', action: 'pull-from-results' }
    }];
    const pucContent = this.map.component.dynComponentSvc.injectComponent(PUCComponent, (puc) => {
      this.puc = puc;
      this.puc.Setup(this.map);
      this.popupSubscriptions.Subscribe(this.puc.actions, (event: any) => {
        switch (event.action) {
          case 'open-popup':
            if (!this.moment) {
              return;
            }
            //const selections = JSON.parse(JSON.stringify(this.resultsPopup.selections));
            //this.ShowResults(this.moment, false);
            this.ShowResults(this.moment, true, true);
            this.ShowPopup();
            //this.resultsPopup.HandleSelections(selections);
            break;
          case 'close-puc':
            this.puc.isClosed = true;
            setTimeout(() => {
              $(this.puc.element).toggleClass('hidden', true);
              this.HidePopup();
              this.map.ClearPUCResults();
            }, 600);
            break;
          case 'send-to-results':
            if (!this.moment) {
              return;
            }
            // this.SendToResult(this.moment);
            this.resultsPopup.listSynchButton.SynchToChannel();


            break;
          case 'pull-from-results':
            this.ShowPopup();
            this.resultsPopup.listSynchButton.SynchFromChannel();

            // this.LoadFromResults();
            break;
        }
      });
      this.queryMarker = new Marker(
        {
          anchor: 'center',
          element: puc.element,
          draggable: false,
          offset: new MBPoint(0, 0)
        }
      );

      this.SetPopup();

    });
    this.inMap = false;

  }
  HandleSynchEvent(event: SynchEvent) {
    const exceptions = ['request-synch', 'send-to-puc']
    if (event.source.indexOf(this.synchProxy.synchId) === 0) {

      if (exceptions.indexOf(event.topic) === -1) {
        return;
      }

    }

    let handlerName = 'Handle';
    const parts = event.topic.split('-');
    for (const part of parts) {
      handlerName += part[0].toUpperCase();
      handlerName += part.substr(1);
    }

    if (typeof this[handlerName] === 'function') {
      this[handlerName](event);
    }

  }

  HandleSelectionChange(event: SynchSelectionsEvent) {
    if (event.source === this.synchProxy.synchId) {
      return;
    }

    switch (event.source) {
      case 'results-list':
        if (!this.resultsPopup.listSyncing) {
          return;
        }
        break;
      case 'info':
        if (!this.resultsPopup.infoSyncing) {
          return;
        }
        break;

    }
    this.isSynchingFeature = true;
    this.moment = event.data.moment;
    this.map.resultsService.history.RegisterSynch(this.synchProxy.synchId, this.moment.id);

    this.resultsPopup.SetSelections(event);
    this.isSynchingFeature = false;

  }
  HandleRequestSynch(event: SynchEvent) {
    if (event.synchTo === this.synchProxy.synchId) {
      switch (event.synchFrom) {
        case 'info':
          this.ShowPopup();
          //this.resultsPopup.infoSynchButton.SynchFromChannel();
          // this.resultsPopup.SetInfoSynching(event.synchronizing);
          break;
        case 'results-list':
          this.ShowPopup();
          // this.resultsPopup.listSynchButton.SynchFromChannel();
          //this.resultsPopup.SetListSynching(true);
          break;
      }
    }
    if (event.synchFrom !== this.synchProxy.synchId) return;


    this.map.resultsService.Synch(
      {
        channel: this.synchProxy.channel,
        data: { moment: this.moment, selections: this.resultsPopup.selections },
        source: this.synchProxy.synchId,
        topic: 'synch-data',
        synchFrom: event.synchFrom,
        synchTo: event.synchTo,
        synchronizing: event.synchronizing

      }
    );
  }
  HandleRenderRequest(event?: SynchEvent) {
    if (!!event) {
      if (event.synchFrom !== this.synchProxy.synchId) {
        return;
      }
    }
    this.map.resultsService.Synch(
      {
        channel: 'renderer',
        data: { moment: this.moment, selections: this.resultsPopup.selections },
        source: this.synchProxy.synchId,
        topic: 'render',
        synchFrom: this.synchProxy.synchId,
        synchTo: 'renderer'
      }
    );
  }
  HandleSynchStateChange(event: SynchEvent) {
    switch (event.source) {
      case 'info':
        this.resultsPopup.SetInfoSynching(event.data.state);
        break;
      case 'results-list':
        this.resultsPopup.SetListSynching(event.data.state);
        break;
    }
  }
  HandleSynchData(event: SynchSelectionsEvent) {
    if (event.synchTo !== this.synchProxy.synchId) {
      return;
    }
    /* if (event.channel !== this.synchProxy.channel) {
      return;
    }
    if (event.source === this.synchProxy.synchId) {
      return;
    }
    */
    this.resultsPopup.isSynchingFeature = true;
    this.resultsPopup.isSettingSelections = true;
    if (!!event.data.moment) {
      this.ShowResults(event.data.moment, true, true, true);

    }
    if (!!event.data.selections) {
      this.map.resultsService.history.RegisterSelection('popup-control', event.data.selections.id);
      this.resultsPopup.SetSelections(event, true);
      this.resultsPopup.HandleSelections(event.data.selections);
    } else {

      // this.ShowResults(this.results);
    }
    this.resultsPopup.isSynchingFeature = false;
    this.resultsPopup.isSettingSelections = false;
    this.HandleRenderRequest();
  }
  HandleSetResults(event: SynchEvent, ignoreSynching: boolean = false) {

    switch (event.source) {
      case 'layer-gallery':
        this.ShowResults(event.data);
        break;
      case 'query-by-feature':
      case 'query':
      case 'roi-query':
        this.synchProxy.channel = event.data.id;
        this.moment = event.data;
        /*if (!this.autoShow) {
          return;
          this.resultsPopup.listSynchButton.SynchToChannel();

        }*/
        this.ShowResults(event.data, true, this.autoShow);
        if (this.map.src.queryToPuc === true) {
          this.ShowPopup();
        }
        break;

      case 'results-list':
        if (event.synchTo !== this.synchProxy.synchId) {
          return;
        }

        if (!!this.resultsPopup) {
          if ((this.resultsPopup.listSyncing === true) || (ignoreSynching === true)) {
            this.ShowResults(event.data);
          }
        }
        break;
    }
  }
  HandleResultStateChange(event: SynchEvent) {

  }
  HandleClearResults(event: SynchEvent) {
    /*if (event.source === 'results-list') {
      this.HidePopup();
      this.HidePUC();
    }*/
  }
  SetPopup() {
    if (!this.popup) {
      const popup = new Popup({ closeOnClick: false, className: 'sl-result-popup' });
      this.popup = popup;
      this.HidePopup();

    }
    this.queryMarker.setPopup(this.popup);
    const content = this.map.component.dynComponentSvc.injectComponent(ResultPopupComponent,
      (resultsPopup) => {
        this.resultsPopup = resultsPopup;
        this.resultsPopup.slMap = this.map;
        this.subscriptions.Subscribe(this.resultsPopup.actions, (event: any) => {
          switch (event.action) {
            case 'load-from-results':
              this.ShowPopup();
              this.resultsPopup.listSynchButton.SynchFromChannel();
              // this.LoadFromResults();
              break;
            case 'show-in-results':
              if (!this.moment) {
                return;
              }
              this.resultsPopup.listSynchButton.SynchToChannel();
              break;
            case 'close':
              this.HidePopup();
              break;
          }
        });
      });
  }

  SetPoint(loc?: LngLat, hidePopup: boolean = true) {
    if (this.map.src.IsSuppressed('query')) return;
    if (!this.queryMarker) {
      return;
    }
    if (!loc) {
      if (!!this.moment?.resultSet?.centroid) {
        loc = this.moment.resultSet.centroid;
      }
    }
    if (!loc) return;
    if (hidePopup === true) {

      this.HidePopup();
    }
    this.queryMarker.setLngLat(loc);
    this.popup.setLngLat(loc);
    if (this.inMap === false) {

      this.queryMarker.addTo(this.map.ui);
      this.popup.addTo(this.map.ui);
      this.popup.setDOMContent(this.resultsPopup.element);
      this.inMap = true;
    }
    $(this.puc.element).toggleClass('hidden', false);


  }
  private showCount = 0;
  ShowPopup() {
    $('.sl-map-container').toggleClass('setting-point', false);


    //window.requestAnimationFrame(() => {
    this.showCount += 1;
    if (this.puc.isClosed === false) {
      this.puc.isClosed = true;
    }
    const popupSelect = $('.sl-result-popup');
    if (popupSelect.length === 0) {
      this.popup.addTo(this.map.ui);
    }
    const popupElements = document.getElementsByClassName('sl-result-popup');
    for (let i = 0; i < popupElements.length; i++) {
      popupElements[i].setAttribute('closed', 'false');
    }
    if (this.showCount === 1) {
      this.showCount = 2;
      requestAnimationFrame(() => {
        this.puc.ul.nativeElement.click();
      })
    }
    // })
  }
  HidePUC() {
    this.showCount = 0;
    $(this.puc.element).toggleClass('hidden', true);
  }
  ZoomToPoint() {
    // this.resultsPopup.ZoomToFeature();
    this.map.ui.jumpTo({ center: this.queryMarker.getLngLat() });
  }

  HidePopup() {
    const popupElements = document.getElementsByClassName('sl-result-popup');
    for (let i = 0; i < popupElements.length; i++) {
      popupElements[i].setAttribute('closed', 'true');
    }
  }
  SendToResult(results) {
    if (!results) {
      return;
    }
    this.results = results;

    this.map.resultsService.Synch(
      {
        channel: this.results.id,
        data: this.results,
        source: this.synchProxy.synchId,
        topic: 'synch popup-control to results'
      }
    );
    // this.map.ShowQueryResults(this.results, true);
  }
  HandleSendToPuc(event: SynchEvent) {
    this.showCount = 0;
    if (event.source === 'popup-control') { return; }
    const allowed = ['results-list', 'info', 'results-virtual-layer'];
    if (allowed.indexOf(event.source) < 0) {
      return;
    }
    this.ShowResults(event.data.moment, true, true);
    window.requestAnimationFrame(() => {
      this.resultsPopup.SetSelections(event, true);
      if (!!event.data.render) this.HandleRenderRequest();
    });

  }
  public ShowResults(moment: ResultMoment, setResults: boolean = true, showPopup: boolean = true, ifNeeded: boolean = false) {
    if (!this.puc.isClosed) {
      if (!!ifNeeded) {
        if (this.moment?.id === moment?.id) {
          if (!this.puc.isClosed) {
            if (!!this.popup) { }
          } return;
        }
      }
    }
    this.moment = moment;
    this.map.resultsService.history.RegisterSynch(this.synchProxy.synchId, this.moment.id);

    this.synchProxy.channel = this.moment.id;

    if (!!this.moment.resultSet) {
      this.results = this.moment.resultSet.results;
      if (this.results.length > 0) {
        if (!!this.results[0].centroid) {
          if (!this.queryMarker) {
            this.SetPopup();
          }
          const centroid = this.results[0].centroid;
          this.SetPoint({ lng: Number(centroid.lng), lat: Number(centroid.lat) }, false);
        }
      }
    } else {
      this.results = this.moment?.resultSet?.results;
    }

    if (showPopup) {
      if (this.resultsPopup.closed === true) {
        this.ShowPopup();

      }
    }
    if (setResults === true) {
      const settingSelections = this.resultsPopup.isSettingSelections;
      const synchingFeature = this.resultsPopup.isSynchingFeature;
      this.resultsPopup.isSettingSelections = false;
      this.resultsPopup.isSynchingFeature = false;

      this.resultsPopup.SetResults(this.map, this.map.component.layerAPI, this.moment);
      this.resultsPopup.isSettingSelections = true;
      this.resultsPopup.isSynchingFeature = synchingFeature;

    }

  }

  public SetPUCVis(onOrOff: boolean) {
    $(this.queryMarker.getElement()).toggleClass('hidden', onOrOff !== true);
  }
  HandleDrawStateChange(info: { drawpane: DrawPaneComponent, is_on: boolean }) {

    this.puc.ToggleInteraction(!info.is_on);

  }
}
